import { Button, Paper, Typography } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import DetailsConnectivity from "./EditWebsiteElements/DetailsConnectivity";
import AdditionalInfo from "./EditWebsiteElements/AdditionalInfo";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { advertisingAccountsEndPointLogic } from "../../../../../logic/PaidTrafficManagement/AdvertisingAccounts/AdvertisingAccounts/advertisingAccountsEndPointLogic";
import { Box, Stack } from "@mui/system";
import Grid from "@mui/material/Grid2";
import { websiteActionEndPointLogic } from "../../../../../logic/AssetManagement/Websites/websiteActionEndPointLogic";
import {
  selectUserDetails,
  selectUserToken,
} from "../../../../../features/userSlice";
import { useSelector } from "react-redux";
import {
  isEmpty,
  validateG4PropertyId,
  validateWebsiteName,
} from "../../../../../utils/websitesValidation";
import SimpleBackdrop from "../../../../BackDrop/BackDrop";


function EditWebsite() {
  const navigate = useNavigate();
  // const { oauthTokenHeader, selectedWebsiteShareuid } = location.state || {};
  const [selectedWebsiteShareuid, setSelectedWebsiteShareuid] = useState(null);
  const oauthTokenHeader = useSelector(selectUserToken) as any;
  const userDetails = useSelector(selectUserDetails) as any;
  const [industryDetails, setIndustryDetails] = useState([]) as any;
  const [territoryDetails, setTerritoryDetails] = useState([]) as any;
  const [loading, setLoading] = useState(false);
  const [loadingWhileEdit, setLoadingWhileEdit] = useState(false);
  const [websiteList, setWebsiteList] = useState([]);
  const [isSyncEnable, setIsSyncEnable] = useState(false) as any;
  const [isWebsiteStatus, setIsWebsiteStatus] = useState(true) as any;
  const [initialWebsiteData, setInitialWebsiteData] = useState({}) as any;
  const [searchParams] = useSearchParams() as any;
  const { financeList } = useSelector((state: any) => state.websiteAction);
  const [editWebsiteData, setEditWebsiteData] = useState({
    ui_site_name: "",
    site_type: "",
    site_url: "",
    industries_shared_uid: "",
    territories_shared_uid: "",
    g4_property_id: "",
    finance_activity_id: "",
  }) as any;

  const [errors, setErrors] = useState({
    ui_site_name: "",
    site_type: "",
    site_url: "",
    industries_shared_uid: "",
    territories_shared_uid: "",
    g4_property_id: "",
    finance_activity_id: "",
  });

  const [singleWebsiteData, SetSingleWebsiteData] = useState({}) as any;

  //-- Get All Websites
  const fetchAllWebsite = async () => {
    if (oauthTokenHeader) {
      try {
        setLoading(true);
        await websiteActionEndPointLogic.getAllWebsites(
          oauthTokenHeader,
          setWebsiteList,
        );
      } catch (error) {
        console.error("Error fetching Websites Setting data", error);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    setSelectedWebsiteShareuid(searchParams.get("websiteSharedUid"));
    // eslint-disable-next-line
  }, []);

  //-- Get All Websites
  useEffect(() => {
    fetchAllWebsite();
    //eslint-disable-next-line
  }, [oauthTokenHeader]);

  //-- Get Single Website data
  useEffect(() => {
    if (websiteList.length > 0) {
      const getSingleWebsite = websiteList.find(
        (website: any) => website.shared_uid === selectedWebsiteShareuid,
      );

      if (getSingleWebsite) {
        SetSingleWebsiteData(getSingleWebsite);
      } else {
        navigate(`/operations/website_actions?${searchParams.toString()}`); // Redirect if no match is found
      }
    }
    // eslint-disable-next-line
  }, [websiteList, selectedWebsiteShareuid]);

  //-- If Superuser then set isSyncEnable to true
  useEffect(() => {
    if (userDetails?.superuser === true) {
      setIsSyncEnable(true);
    } else {
      setIsSyncEnable(false);
    }
  }, [userDetails?.superuser]);

  useEffect(() => {
    setEditWebsiteData({
      ui_site_name: singleWebsiteData?.ui_site_name || "",
      site_type: singleWebsiteData?.site_type || "",
      site_url: singleWebsiteData?.site_url || "",
      g4_property_id: singleWebsiteData?.g4_property_id || "",
    });
    //eslint-disable-next-line
  }, [singleWebsiteData]);

  //-- Get Industries, Territories and Finance List
  useEffect(() => {
    const getRequiredData = async () => {
      try {
        setLoading(true);
        const requests = [
          websiteActionEndPointLogic.fetchFinanceList(oauthTokenHeader),
          advertisingAccountsEndPointLogic.getIndustry(
            setIndustryDetails,
            oauthTokenHeader,
          ),
          advertisingAccountsEndPointLogic.getTerritory(
            setTerritoryDetails,
            oauthTokenHeader,
          ),
        ];
        await Promise.allSettled(requests);
      } catch (error) {
        console.error("Error fetching required data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (oauthTokenHeader) {
      getRequiredData();
    }
  }, [oauthTokenHeader]);

  //-- Set Industry Id and Territory Id from Industry and Territory name and Finance Id
  useEffect(() => {
    if (
      singleWebsiteData?.industries__industry_name &&
      industryDetails.length > 0
    ) {
      const selectedIndustry = industryDetails.find(
        (industry: any) =>
          industry.industry_name ===
          singleWebsiteData?.industries__industry_name,
      );
      setEditWebsiteData((prevData: any) => ({
        ...prevData,
        industries_shared_uid: selectedIndustry?.shared_uid || "",
      }));
    }
    if (
      singleWebsiteData?.territories__territory_name &&
      territoryDetails.length > 0
    ) {
      const selectedTerritory = territoryDetails.find(
        (territory: any) =>
          territory.territory_name ===
          singleWebsiteData?.territories__territory_name,
      );
      setEditWebsiteData((prevData: any) => ({
        ...prevData,
        territories_shared_uid: selectedTerritory?.shared_uid || "",
      }));
    }

    if (financeList?.length > 0) {
      const selectedFinance = financeList?.find(
        (finance: any) =>
          finance?.name === singleWebsiteData?.finance_activity__name,
      );
      setEditWebsiteData((prevData: any) => ({
        ...prevData,
        finance_activity_id: selectedFinance?.id || "",
      }));
    }
    //eslint-disable-next-line
  }, [industryDetails, territoryDetails, financeList, singleWebsiteData]);

  //-- Set Data in Initial State so we can check any field data is changed or not
  useEffect(() => {
    setInitialWebsiteData(singleWebsiteData);
    //eslint-disable-next-line
  }, [singleWebsiteData]);

  const checkEditOrNot = () => {
    //-- Get the industry and territory shared_uid from initial data
    const initialIndustryUid = industryDetails.find(
      (industry: any) =>
        industry.industry_name ===
        initialWebsiteData?.industries__industry_name,
    )?.shared_uid;

    const initialTerritoryUid = territoryDetails.find(
      (territory: any) =>
        territory.territory_name ===
        initialWebsiteData?.territories__territory_name,
    )?.shared_uid;

    const initialFinanceId = financeList?.find(
      (finance: any) =>
        finance?.name === initialWebsiteData?.finance_activity__name,
    )?.id;

    //-- If edited data is not same as initial data then set isSyncEnable and isWebsiteStatus to false
    if (
      editWebsiteData?.ui_site_name !== initialWebsiteData?.ui_site_name ||
      editWebsiteData?.site_type !== initialWebsiteData?.site_type ||
      editWebsiteData?.site_url !== initialWebsiteData?.site_url ||
      editWebsiteData?.industries_shared_uid !== initialIndustryUid ||
      editWebsiteData?.territories_shared_uid !== initialTerritoryUid ||
      editWebsiteData?.g4_property_id !== initialWebsiteData?.g4_property_id ||
      editWebsiteData?.finance_activity_id !== initialFinanceId
    ) {
      setIsSyncEnable(false);
      setIsWebsiteStatus(false);
    } else {
      setIsSyncEnable(true);
      setIsWebsiteStatus(true);
    }
  };

  //-- On Input Change set Data in EditWebsiteData State
  const handlechange = (name: string, value: any) => {
    setEditWebsiteData((prevValue: any) => ({
      ...prevValue,
      [name]: value,
    }));

    //-- Function for If any of field data changed or not (if change then below buttons(Sync and Website) will disabled)
    checkEditOrNot();

    //-- Set error message for those fields are mandatory
    let errorMsg = "";
    if (name === "ui_site_name") {
      errorMsg = validateWebsiteName(value);
    } else if (name === "site_type") {
      errorMsg = isEmpty(value);
    } else if (name === "industries_shared_uid") {
      errorMsg = isEmpty(value);
    } else if (name === "territories_shared_uid") {
      errorMsg = isEmpty(value);
    } else if (name === "g4_property_id") {
      errorMsg = validateG4PropertyId(value);
    } else if (name === "finance_activity_id") {
      errorMsg = isEmpty(value);
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: errorMsg,
    }));
  };

  //-- Click on Save changes Button to update Website data
  const modifiedWebsiteData = async () => {
    try {
      setLoadingWhileEdit(true);

      // Check if URL has changed
      const hasUrlChanged =
        editWebsiteData.site_url !== initialWebsiteData.site_url;

      // Get the industry and territory shared_uid from initial data for comparison
      const initialIndustryUid = industryDetails.find(
        (industry: any) =>
          industry.industry_name ===
          initialWebsiteData?.industries__industry_name,
      )?.shared_uid;

      const initialTerritoryUid = territoryDetails.find(
        (territory: any) =>
          territory.territory_name ===
          initialWebsiteData?.territories__territory_name,
      )?.shared_uid;

      const initialFinanceId = financeList?.find(
        (finance: any) =>
          finance?.name === initialWebsiteData?.finance_activity__name,
      )?.id;

      // Check if other fields have changed
      const hasOtherFieldsChanged =
        editWebsiteData.ui_site_name !== initialWebsiteData.ui_site_name ||
        editWebsiteData.site_type !== initialWebsiteData.site_type ||
        editWebsiteData.industries_shared_uid !== initialIndustryUid ||
        editWebsiteData.territories_shared_uid !== initialTerritoryUid ||
        editWebsiteData.g4_property_id !== initialWebsiteData.g4_property_id ||
        editWebsiteData.finance_activity_id !== initialFinanceId;

      let urlUpdateSuccess = true;
      let otherFieldsUpdateSuccess = true;

      // Call URL update API if URL has changed
      if (hasUrlChanged) {
        const urlData = {
          site_url: editWebsiteData.site_url,
        };
        const urlRes = await websiteActionEndPointLogic.updateWebsiteURL(
          urlData,
          selectedWebsiteShareuid,
          oauthTokenHeader,
        );

        // Check if response is defined and has status 200
        if (!urlRes || urlRes.status !== 200) {
          urlUpdateSuccess = false;
        }
      }

      // Call other fields update API if other fields have changed
      if (hasOtherFieldsChanged) {
        const otherFieldsData = {
          ui_site_name: editWebsiteData.ui_site_name,
          site_type: editWebsiteData.site_type,
          industries_shared_uid: editWebsiteData.industries_shared_uid,
          territories_shared_uid: editWebsiteData.territories_shared_uid,
          g4_property_id: editWebsiteData.g4_property_id || null,
          finance_activity_id: editWebsiteData.finance_activity_id,
        };
        const otherFieldsRes =
          await websiteActionEndPointLogic.updateEditWebsitesData(
            otherFieldsData,
            selectedWebsiteShareuid,
            oauthTokenHeader,
          );

        // Check if response is defined and has status 200
        if (!otherFieldsRes || otherFieldsRes.status !== 200) {
          otherFieldsUpdateSuccess = false;
        }
      }

      // If all API calls were successful, redirect
      if (urlUpdateSuccess && otherFieldsUpdateSuccess) {
        handleCancel();
      }
    } catch (error: any) {
      console.error("Error Updating Websites data", error);
    } finally {
      setLoadingWhileEdit(false);
      if (userDetails?.superuser === true) {
        setIsSyncEnable(true);
      } else {
        setIsSyncEnable(false);
      }
      setIsWebsiteStatus(true);
    }
  };
  //-- When cliking in cancel button
  const handleCancel = () => {
    fetchAllWebsite();
    navigate("/operations/website_actions"); // Redirect to the Website List
  };

  //-- Check form is valid or not (if not valid button disabled)
  const { g4_property_id: _g4, ...requiredFields } = editWebsiteData;
  const isFormValid =
    Object.values(errors).every((err) => err === "") &&
    Object.values(requiredFields).every(
      (value: any) => value?.toString().trim() !== "",
    );

  return (
    <>
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <Paper sx={{ padding: "8px 16px" }}>
          <Typography fontSize={24}>Edit Website</Typography>
          <DetailsConnectivity
            getSingleWebsite={singleWebsiteData}
            editWebsiteData={editWebsiteData}
            handlechange={handlechange}
            industryDetails={industryDetails}
            territoryDetails={territoryDetails}
            errors={errors}
          ></DetailsConnectivity>
          <AdditionalInfo
            getSingleWebsite={singleWebsiteData}
            editWebsiteData={editWebsiteData}
            financeList={financeList}
            isSyncEnable={isSyncEnable}
            isWebsiteStatus={isWebsiteStatus}
            handlechange={handlechange}
            oauthTokenHeader={oauthTokenHeader}
            refreshWebsites={fetchAllWebsite}
            errors={errors}
          ></AdditionalInfo>
          <Grid
            size={4}
            sx={{
              pl: 2,
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-end",
              alignItems: "flex-end",
            }}
          ></Grid>
          <Box>
            <Stack
              flexDirection={"row"}
              justifyContent={"end"}
              marginTop={4}
              gap={1}
            >
              <Button color="secondary" variant="outlined">
                <Stack flexDirection={"row"} onClick={handleCancel} gap={1}>
                  <ArrowBackIosNewIcon fontSize="small" />
                  Cancel
                </Stack>
              </Button>
              <Button
                data-tracker="42"
                variant="contained"
                onClick={modifiedWebsiteData}
                disabled={!isFormValid}
                color="secondary"
                sx={{ display: "flex" }}
              >
                <Stack alignItems={"center"} flexDirection={"row"} gap={1}>
                  Save Changes
                </Stack>
                {loadingWhileEdit ? <SimpleBackdrop /> : null}
              </Button>
            </Stack>
          </Box>
        </Paper>
      )}
    </>
  );
}

export default EditWebsite;
